export default __webpack_public_path__ + "1a271727e67611cb09a06b0b5e6feb72.ttf";